import { BaseApi, ApiResponse } from "../utils/request";

// 兑换码相关类型定义
export interface SetCouponRequest {
  coupon: string;
}

export interface SetCouponResponse {
  success: boolean;
  message?: string;
  reward?: {
    type: string;
    amount: number;
    description?: string;
  };
}

/**
 * 用户资料 API 类
 * 继承 BaseApi，提供用户资料相关的 API 接口
 */
export class ProfileApi extends BaseApi {
  constructor() {
    super();
  }

  /**
   * 使用兑换码
   * @param data 兑换码数据
   * @returns Promise<ApiResponse<SetCouponResponse>>
   */
  async setCoupon(
    data: SetCouponRequest
  ): Promise<ApiResponse<SetCouponResponse>> {
    return this.post<SetCouponResponse>("/api/user/set_coupon", data);
  }
}

export const profileApi = new ProfileApi();

// 便捷方法
export const setCoupon = (coupon: string) => profileApi.setCoupon({ coupon });
